import { InvoiceStatus } from "@gymflow/types";
import { QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { apiV2 } from "../../apiV2";
import { queryClient } from "../../QueryClient";

const keys = {
  all: () => ["memberApiVoucher"] as QueryKey,
  order: (params: unknown) => [...keys.all(), "order", params] as QueryKey,
};

export const memberApiVoucher = {
  keys,
  queries: {},
  infiniteQueries: {},
  mutations: {
    order: () => ({
      mutationKey: keys.order({}),
      mutationFn: async (params: {
        orderKey: string;
        paymentMethodId?: string;
        amount?: string;
      }) => {
        return (
          await api.put<{
            invoiceNumber: string;
            invoiceStatus: InvoiceStatus;
            voucherId: string;
            userId: string | undefined;
          }>(`customer/voucher-checkout/${params.orderKey}`, {
            paymentMethodId: params.paymentMethodId,
            amount: params.amount,
          })
        ).data;
      },
      onSettled: () =>
        queryClient.invalidateQueries({
          queryKey: apiV2.member.member.keys.all(),
        }),
    }),
  },
};
